<template>
  <nav class="PaB-category-nav">
    <scroller fade-color="rgb(209, 211, 212)" fade-color-stop="rgba(209, 211, 212, 0)">
      <ul class="PaB-category-menu">
        <li :class="{'is-active': current_cat.slug === 'all'}">
          <router-link :to="{name: 'product-listing', params: { category: 'all' } }">All</router-link>
        </li>
        <li v-for="category in categories" v-bind:key="category.slug" :class="{'is-active': current_cat.slug === category.slug}">
          <router-link :to="{name: 'product-listing', params: { category: category.slug } }">{{ category.name }}</router-link>
        </li>
      </ul>
    </scroller>
  </nav>
</template>

<style lang="scss" scoped>
.PaB-category-nav {
  background-color: rgba(#7f7f7f, 0.2);
  position: relative;

  a {
    opacity: 0.9;
    color: inherit;
    text-decoration: none;
    &:hover {
      opacity: 1;
    }
  }
}
.PaB-category-menu {
  padding: 0;
  white-space: nowrap;
  list-style: none;
  margin: 0;
  display: flex;

  li {
    list-style: none;
  }

  a {
    display: block;
    padding: 10px;
  }
}
</style>

<script>
import Scroller from '@/components/Scroller'
export default {
  components: {
    Scroller
  },
  computed: {
    categories () {
      return this.$store.state.products.categories
    },
    current_cat () {
      return this.$store.getters['products/getCategory']
    }
  }
}
</script>
